export default {
  title: 'Kênh thanh toán dịch vụ',
  header: 'Kênh thanh toán',
  footer: '✅ Kênh thanh toán chính thức cho các dịch vụ thuộc AutoShopee & Subcheo',
  company: 'AutoShopee & Subcheo',
  service: {
    pusher: {
      key: '89368ca13564f7ecb8bc',
      cluster: 'ap1',
      event: 'payment',
    },
  },
  contact: {
    phone: '0904628850',
    zalo: 'https://zalo.me/2141564390855067259',
  },
  currency: 'VNĐ',
  sound: {
    paymentSuccess: '/audio/success.mp3',
  },
};
